import { render, staticRenderFns } from "./ClinicConceptForm.vue?vue&type=template&id=7127a01f&scoped=true"
import script from "./ClinicConceptForm.vue?vue&type=script&lang=js"
export * from "./ClinicConceptForm.vue?vue&type=script&lang=js"
import style0 from "./ClinicConceptForm.vue?vue&type=style&index=0&id=7127a01f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127a01f",
  null
  
)

export default component.exports